export var AppointmentStatus;
(function (AppointmentStatus) {
    AppointmentStatus["Scheduled"] = "SCHEDULED";
    AppointmentStatus["Arrived"] = "ARRIVED";
    AppointmentStatus["CheckedIn"] = "CHECKED_IN";
    AppointmentStatus["InVisit"] = "IN_VISIT";
    AppointmentStatus["CheckedOut"] = "CHECKED_OUT";
})(AppointmentStatus || (AppointmentStatus = {}));
